//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { React, useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'

//
// ─── IMPORTING UTILS ───────────────────────────────────────
//
import Api from '../../contexts/Api'

//
// ─── IMPORTING COMPONENTS ───────────────────────────────────────
//
import Title from '../Title'
import ModalScanConfirmation, { formatScanDate } from '../Modals/Qr/Success/ModalScanConfirmation'

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const UserScans = () => {
  //
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [scans, setScans] = useState([])
  const [selected, setSelected] = useState(null)

  //
  // ─── STYLE DEFINITION ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    list: { padding: '0 20px' },
    item: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0',
      borderBottom: '1px solid rgba(0,0,0,.08)',
      cursor: 'pointer',
    },
    store: { fontWeight: 600 },
    date: { fontSize: 13, opacity: .7 },
    empty: { padding: '0 20px', fontStyle: 'italic', opacity: .7 },
  })
  const classes = useStyle()

  //
  // ─── GET USER SCANS ───────────────────────────────────────
  //
  useEffect(() => {
    const fetchScans = async () => {
      const getScans = await Api({ endpoint: '/analytics/scans', method: 'GET' })
      if (getScans && getScans.success) setScans(getScans.data)
    }
    fetchScans()
  }, [])

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <>
    {selected && <ModalScanConfirmation open={!!selected} scan={selected} onClose={() => setSelected(null)} />}

    <Title text="Mes passages" />
    {scans.length ? <div className={classes.list}>
      {scans.map((scan, index) => {
        return <div key={`${scan.time_create}-${index}`} className={classes.item} onClick={() => setSelected(scan)}>
          <span className={classes.store}>{scan.store_name}</span>
          <span className={classes.date}>{formatScanDate(scan.time_create)}</span>
        </div>
      })}
    </div> : <p className={classes.empty}>Aucun passage enregistré pour le moment.</p>}
  </>
}

export default UserScans;
